import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {AuthService} from './auth.service';
import {RoleService} from './role.service';

/**
 * Customer core-operations pages (vehicles, LPR, cameras, monitoring, etc.).
 * Mirrors RoleService.canAccessCoreOps: Admin/Member yes; Sales Manager and
 * platform Super User no (SU uses separate admin/diagnostics surfaces).
 * Backend permissions remain the data-security boundary.
 */
@Injectable({
    providedIn: 'root',
})
export class CoreOpsAccessGuardService implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router,
        private roleService: RoleService,
    ) {
    }

    canActivate(): boolean {
        // Fail closed if the session is not established (AuthGuard is usually first).
        if (!this.auth.isAuthenticated()) {
            void this.router.navigate(['/login']);
            return false;
        }

        const userInfo = this.auth.getCurrentUserInfo();
        const groups = userInfo?.role;

        if (this.roleService.canAccessCoreOps(groups)) {
            return true;
        }

        this.router.navigate([this.roleService.getDefaultRoute(groups)]);
        return false;
    }
}
